import React from "react";
import { Button } from "@/components/ui/button";
import { RotateCw } from "lucide-react";

export const RefreshButton = ({ onClick, refreshing = false, testId = "refresh-button", className = "" }) => (
  <Button
    type="button"
    variant="outline"
    size="sm"
    onClick={onClick}
    disabled={refreshing}
    data-testid={testId}
    aria-label="Refresh"
    className={`h-9 rounded-lg ${className}`}
  >
    <RotateCw className={`h-4 w-4 ${refreshing ? "animate-spin" : ""}`} />
    <span className="ml-1.5 hidden sm:inline">{refreshing ? "Refreshing" : "Refresh"}</span>
  </Button>
);

export default RefreshButton;
